var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',[_c('Message',{attrs:{"content":_vm.content,"user":_vm.validatedUser,"timestamp":_vm.created,"media":_vm.message.media,"highlights":_vm.highlights,"type":_vm.message.type,"timezone":_vm.timezone,"customer":_vm.customer,"automatedResponse":_vm.message.automatedResponse}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }